import React, { FC } from 'react';
import { BasicContainer, FlexDynamic, FlexRow, ToggleCheckbox } from '@minecraft.atoms';
import { useTranslation } from '@blocs.i18n';
import { BestDeal } from '../PlanSelection/SelectPlanHead';
import { PlanType } from '../usePlans';
import { CheckoutProps } from './types';
import { UnlimitedMediaUpsell } from './UnlimitedMediaUpsell';

export interface CheckoutHeadProps {
  isAnnual: boolean;
  setIsAnnual: (isAnnual: boolean) => void;
  isToggleLocked?: boolean;
  purchaseableItems?: CheckoutProps['previewMediaPurchase']['items'];
  plans: PlanType[];
  countryCode: CheckoutProps['countryCode'];
  currencyCode: CheckoutProps['currencyCode'];
}

export const CheckoutHead: FC<CheckoutHeadProps> = React.memo(
  ({ isAnnual, setIsAnnual, isToggleLocked, purchaseableItems, plans, countryCode, currencyCode }) => {
    const { t } = useTranslation();

    return (
      <BasicContainer>
        <UnlimitedMediaUpsell
          show={purchaseableItems?.length > 0}
          plans={plans}
          countryCode={countryCode}
          currencyCode={currencyCode}
        />
        <FlexDynamic
          direction="column"
          justifyContent="space-between"
          alignItems="start"
          gap="4"
          w="full"
          grow={0}
          shrink={0}
          mdProps={{ direction: 'row', gap: '2', alignItems: 'center' }}
        >
          <FlexRow gap="2">
            <ToggleCheckbox
              checked={isAnnual}
              onChange={() => setIsAnnual(!isAnnual)}
              toggleOffText={t('common:paywall.payMonthly')}
              toggleOnText={t('common:paywall.payYearly')}
              isLocked={isToggleLocked}
              ariaLabel={isAnnual ? 'View Monthly Plans' : 'View Annual Plans'}
            >
              <BestDeal text={t('common:paywall.bestDeal')} />
            </ToggleCheckbox>
          </FlexRow>
        </FlexDynamic>
      </BasicContainer>
    );
  }
);
